import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { TraceContainer, getTraceData } from '@mi/rn-trace';
import { AppContext } from '../../navigator/AppContext';

const StatTraceContainer = (props) => {
  const { traceId, onPress, children, traceData, scmv2, pageName, traceRef, ...args } = props;
  const parsedTraceData = getTraceData(pageName, traceId, {
    traceData,
    type: 'touch',
  });
  const testID = `${parsedTraceData.c}.${parsedTraceData.d}`;
  const context = useContext(AppContext);

  return (
        <TraceContainer
          traceId={traceId}
          onPress={onPress}
          children={children}
          traceData={traceData}
          scmv2={scmv2}
          pageName={pageName || context?.navigatorName}
          statSend={context?.YPStatSend}
          traceRef={traceRef}
          testID={testID}
          {...args}
        />
  );
};

StatTraceContainer.propTypes = {
  traceId: PropTypes.string, // 根据traceid找到响应的配置config
  onPress: PropTypes.func, // 如果是点击的话，把原来的TouchableWithoutFeedback组件的onPress传过来
  children: PropTypes.node, // 该组件中包的dom, 将原封不动展示
  traceData: PropTypes.object, // 需要上报的数据，改参数将被传递给config中的func
  // type: PropTypes.array, // 只能是['visible'] 、['touch'] 或者 ['visible', 'touch'], 不区分大小写 废弃
  scmv2: PropTypes.string,
  pageName: PropTypes.string, // b位 (可不传业务组件中处理了)
  TouchCompt: PropTypes.object, //  默认TouchableWithoutFeedback，可不传
  traceRef: PropTypes.object, //  自定义曝光时机使用, 默认曝光的情况下不传
  isCustomVisible: PropTypes.bool, // 是否在第一次加载的时候曝光
};

export default StatTraceContainer;
